module.exports = __webpack_public_path__ + "static/media/Developer.9d172d5b.svg";